import { connect } from "react-redux";
import { withRouter } from 'react-router';
import { XS_MOBILE, SM_MOBILE, MD_TABLET, LG_TABLET } from "../../../../../constants/textConstants";
import { IconButton } from "../../index";

const mapStateToProps = (state) => {
    return {
        screenBreakPoint: state.common.screenBreakPoint
    }
};

export const HeadingPrintCTA = withRouter(connect(mapStateToProps)(({
    onClick,
    to,
    screenBreakPoint,
}) => {

    return ((onClick || to)
        ? <IconButton
            icon="printer"
            onClick={onClick}
            to={to}
            size={"medium"}
        />
        : null
    )
}));